module.exports = __webpack_public_path__ + "static/GAO_ST-aee78130289e277df8404a09b072c19c.jpg";